<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rfcCzq/tc-custom/9781466886322.jpg?1729034209052" alt="This image is the cover for the book Perfect Comeback of Caroline Jacobs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perfect Comeback of Caroline Jacobs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the beloved author of <i>Memoirs of an Imaginary Friend </i>comes a wonderful new novel about a broken woman who faces her past and, armed with the perfect comeback, finds a way to set herself free.</b><br/><br/>Caroline Jacobs has lost herself. She's a wife, mother (to a tattooed teenage daughter she avoids), Sears Portrait Studio photographer, and wimp. Asserting herself, taking the reins, or facing life head-on are not in her repertoire. So when Caroline suddenly cracks and screams "Fuck you!" at the PTA president, she is shocked. So is her husband. So is the PTA president. So is everyone. <br/><br/>But Caroline soon realizes the true cause of her outburst can be traced back to something that happened to her as a teenager, a scarring betrayal by her best friend Emily. This act changed Caroline's life forever. So, with a little bit of bravery flowing through her veins, Caroline decides to go back to her home town and confront Emily. She busts her daughter Polly out of school, and the two set off to deliver the perfect comeback, which is twenty-five years in the making. But nothing goes as planned. Long buried secrets begin to rise to the surface, and Caroline will have to face much more than one old, bad best friend. <br/><br/>A heartwarming story told with Matthew Dicks' signature wit, <i>The Perfect Comeback of Caroline Jacobs </i>is a deceptively simple novel about the ways in which our childhood experiences reverberate through our lives, and the bravery of one woman trying to change her life and finds true understanding of her daughter, and herself, along the way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew Dicks
      </h2>
      
      <p class="authorDescription body article"><P>MATTHEW DICKS is a writer and elementary school teacher. His articles have been published in the <I>Hartford Courant, </I>he has been a featured author at the Books on the Nightstand retreat, and he is a Moth StorySLAM champion. He is the author of three previous novels, <I>Something Missing, Unexpectedly Milo, </I>and <I>Memoirs of an Imaginary Friend, </I>an international bestseller<I>. </I>His novels have been translated into more than 25 languages. Dicks lives in Newington, Connecticut, with his wife, Elysha, and their two children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72e9dcbc